export default __webpack_public_path__ + "static/media/top1.d1d406af.svg";